import { render, staticRenderFns } from "./ListAdminMessages.vue?vue&type=template&id=32876e02&scoped=true&"
import script from "./ListAdminMessages.vue?vue&type=script&lang=js&"
export * from "./ListAdminMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32876e02",
  null
  
)

export default component.exports